// import React from "react";
// import CountUp from "react-countup";
// import ab1 from "../Images/ab1.jpeg";
// import ab2 from "../Images/ab2.jpg";
// import ab4 from "../Images/ab4.jpeg";
// import "./AboutSection.css";

// export default function AboutSection() {
//   return (
//     <section className="about-luxury">
//       <div className="background-split">
//         <div className="bg-left"></div>
//         <div className="bg-right"></div>
//       </div>

//       <div className="overlay"></div>

//       <div className="about-inner luxury-content">
        
//         <p className="about-intro" data-aos="fade-up">
//           Infosight is{" "}
//           <span className="highlight">redefining</span> the future of building
//           technologies — from <span className="highlight">IBMS</span> to{" "}
//           <span className="highlight">Acoustics</span>, with over{" "}
//           <span className="highlight">300+</span> iconic projects across the GCC.
//         </p>

//         <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
//           <div className="stat-card">
//             <div className="stat-number">
//               <CountUp end={300} duration={2.5} />+
//             </div>
//             <div className="stat-label">Projects</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-number">
//               <CountUp end={150} duration={2.5} />+
//             </div>
//             <div className="stat-label">Hotels</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-number">
//               <CountUp end={20} duration={2.5} />+
//             </div>
//             <div className="stat-label">Govt. / Corporate</div>
//           </div>
//           <div className="stat-card">
//             <div className="stat-number">
//               <CountUp end={500} duration={3} />+
//             </div>
//             <div className="stat-label">Bed Hospital Design</div>
//           </div>
//         </div>
//       </div>

  
//     </section>
//   );
// }


import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import "./AboutSection.css";

export default function AboutSection() {
  const [stats, setStats] = useState([]);

  // Fetch Status Cards
  useEffect(() => {
    async function fetchStats() {
      try {
        const res = await fetch("https://infosightapi.emedha.in/api/status-cards");
        const data = await res.json();
        setStats(data);
      } catch (err) {
        console.error("Failed to fetch status cards:", err);
      }
    }

    fetchStats();
  }, []);

  return (
    <section className="about-luxury">
      <div className="background-split">
        <div className="bg-left"></div>
        <div className="bg-right"></div>
      </div>

      <div className="overlay"></div>

      <div className="about-inner luxury-content">
        {/* <p className="about-intro" data-aos="fade-up">
          Infosight is{" "}
          <span className="highlight">redefining</span> the future of building
          technologies — from <span className="highlight">IBMS</span> to{" "}
          <span className="highlight">Acoustics</span>, with over{" "}
          <span className="highlight">300+</span> iconic projects across the GCC.
        </p> */}

        <p className="about-intro" data-aos="fade-up">
  Infosight is a{" "}
  <span className="highlight">trusted design Consulting Firm </span> delivering
  specialized expertise across{" "}
  <span className="highlight">
    {/* Acoustics, IBMS, AV, IT/ICT, Security & SRA */}
    Acoustics, Security, SRA, IT/ICT, IBMS, AV, Sustainability & Green Building, Project Management
  </span>
  . Serving Hospitality, Mixed Used, Corporate, Government, we
  deliver{" "}
  <span className="highlight">precision-engineered</span>, scalable, and
  future-ready solutions.
</p>
  <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
          {stats.filter(item => item.id === 1).map((item) => (
            <div className="stat-card" key={item.id}>
              <div className="stat-number">
                <CountUp end={item.count} duration={2.5} />+
              </div>
              <div className="stat-label">{item.name}</div>
            </div>
          ))}
        </div>

        <div className="about-stats" data-aos="fade-up" data-aos-delay="200">
          {stats.filter(item => item.id !== 1).map((item) => (
            <div className="stat-card" key={item.id}>
              <div className="stat-number">
                <CountUp end={item.count} duration={2.5} />+
              </div>
              <div className="stat-label">{item.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
